import { render, staticRenderFns } from "./addDefaultRules.vue?vue&type=template&id=0af82b73&scoped=true&"
import script from "./addDefaultRules.vue?vue&type=script&lang=js&"
export * from "./addDefaultRules.vue?vue&type=script&lang=js&"
import style0 from "./addDefaultRules.vue?vue&type=style&index=0&id=0af82b73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af82b73",
  null
  
)

export default component.exports